import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from '../../../Components/Components/LoadingSpinner';
import { CheckBox } from 'devextreme-react/check-box';
import { CapitalizeFirstLowercaseRest, ConvertPriceToString } from '../../../Helpers/CustomConverter';
import { useParams } from '../../../Providers/ParamsProvider.jsx';
import { getIndeksHeader } from '../../../Helpers/ValidatorHelper.jsx';
import useGetProductIndexWithMask from '../../../Components/BasketPage/Hooks/useGetProductIndexWithMask.jsx';

const SingleOrderItems = ({ items, isLoading, handleSelectUnSelectAllItems, handleCheckUncheckItem }) => {
    const { t } = useTranslation()
    const [selectAllItems, setSelectAllItems] = useState(false)
    const { license, isMobile } = useParams()

    return (
        <div>
            <div className='row justify-content-center'>
                <div className='justify-content-center mt-2'>
                    <div className='panel-header-title'>{t('product_list')}</div>
                    <div className="row mt-2 mb-3" style={{ marginLeft: '0.01%' }}>
                        <div className="col-auto text-start">
                            <CheckBox
                                className="custom-checkbox"
                                value={selectAllItems}
                                defaultValue={false}
                                onValueChange={() => {
                                    setSelectAllItems(prev => !prev)
                                    handleSelectUnSelectAllItems(items, !selectAllItems)
                                }}
                            />
                        </div>
                        <div className="col-auto text-start">
                            <span>zaznacz wszystko</span>
                        </div>
                    </div>
                    <div className='table-responsive'>

                        <table className={`${isMobile ? 'table-font-small' : ''} table table-bordered`}>
                            <thead>
                                <tr>
                                    <th style={{ width: "3%" }}></th>
                                    <th style={{ width: "4%", verticalAlign: 'top' }}>LP</th>
                                    <th style={{ width: "9%", verticalAlign: 'top' }}>{getIndeksHeader(license)}</th>
                                    <th style={{ width: "29%" }}>NAZWA<br />CECHA</th>
                                    <th style={{ width: "10%", textAlign: 'right', verticalAlign: 'top' }}>CENA NETTO PLN</th>
                                    <th style={{ width: "7%", verticalAlign: 'top' }}>STATUS</th>
                                    <th style={{ width: "4%", verticalAlign: 'top' }}>JEDN</th>
                                    <th style={{ width: "7%", textAlign: 'right' }}>ZAMÓWIONE<br />ZAREZERWOWANE</th>
                                    <th style={{ width: "7%", textAlign: 'right' }}>ZADYSPONOWANE<br />ZREALIZOWANE</th>
                                    <th style={{ width: "10%", textAlign: 'right', verticalAlign: 'top' }}>SUMA NETTO PLN</th>
                                    <th style={{ width: "10%", textAlign: 'right', verticalAlign: 'top' }}>SUMA BRUTTO PLN</th>
                                </tr>
                            </thead>
                            <tbody>
                                {!isLoading && items && items.length > 0 && items.map((item, key) => {
                                    return <OrderItem key={key} rowId={key} item={item} isCheckedParam={selectAllItems} handleCheckUncheckItem={handleCheckUncheckItem} />
                                })}
                                <TableDataSummary
                                    items={items}
                                />
                            </tbody>
                        </table>
                        {isLoading && <LoadingSpinner width={2} height={2} />}
                        {!isLoading && items && items.length === 0 && (
                            <div style={{ textAlign: "center " }}>
                                {t("message_norecords_orders_items_page")}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

const TableDataSummary = ({ items }) => {
    const totalQtyStock = items.reduce((acc, item) => acc + item.qtyStock, 0)
    const totalRezQty = items.reduce((acc, item) => acc + item.rezQty, 0)
    const totalDyspQty = items.reduce((acc, item) => acc + item.dyspQty, 0)
    const totalSellQty = items.reduce((acc, item) => acc + item.sellQty, 0)
    const totalNetValue = items.reduce((acc, item) => acc + item.priceNetto * item.qtyStock, 0)
    const totalGrossValue = items.reduce((acc, item) => acc + item.priceBrutto * item.qtyStock, 0)
    return (
        <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td style={{ textAlign: 'right' }}>{totalQtyStock}<br />{totalRezQty}</td>
            <td style={{ textAlign: 'right' }}>{totalDyspQty}<br />{totalSellQty}</td>
            <td style={{ textAlign: 'right' }}>
                <div className='d-flex flex-column'>
                    <b>{ConvertPriceToString(totalNetValue, null)}</b>
                </div>
            </td>
            <td style={{ textAlign: 'right' }}>
                <div className='d-flex flex-column'>
                    <span>{ConvertPriceToString(totalGrossValue, null)}</span>
                </div>
            </td>
            <td></td>
        </tr>
    )
}

const OrderItem = ({ rowId, item, isCheckedParam, handleCheckUncheckItem }) => {
    const [isChecked, setIsChecked] = useState(isCheckedParam)
    const { getProductIndexWithMask } = useGetProductIndexWithMask()

    useEffect(() => {
        setIsChecked(isCheckedParam)
    }, [isCheckedParam])

    return (
        <tr>
            <td onClick={(e) => e.stopPropagation()}>
                <CheckBox
                    className="custom-checkbox"
                    value={isChecked}
                    defaultValue={false}
                    onValueChange={() => {
                        setIsChecked(prev => !prev)
                        handleCheckUncheckItem(item, !isChecked)
                    }}
                />
            </td>
            <td style={{ textAlign: 'left' }}>{rowId + 1}</td>
            <td style={{ textAlign: 'left' }}>{getProductIndexWithMask(item.index)}</td>
            <td>{CapitalizeFirstLowercaseRest(item.name)}<br />{CapitalizeFirstLowercaseRest(item.description)}</td>
            <td style={{ textAlign: 'right' }}>{ConvertPriceToString(item.priceNetto, null)}</td>
            <td></td>
            <td>{item.jmh}</td>
            <td style={{ textAlign: 'right' }}>{item.qtyStock}<br />{item.rezQty}</td>
            <td style={{ textAlign: 'right' }}>{item.dyspQty}<br />{item.sellQty}</td>
            <td style={{ textAlign: 'right' }}>{ConvertPriceToString(item.priceNetto * item.qtyStock, null)}</td>
            <td style={{ textAlign: 'right' }}>{ConvertPriceToString(item.priceBrutto * item.qtyStock, null)}</td>
        </tr>
    )
}

export default SingleOrderItems